import { render, staticRenderFns } from "./Canciones.vue?vue&type=template&id=2d9209be&scoped=true"
import script from "./Canciones.vue?vue&type=script&lang=js"
export * from "./Canciones.vue?vue&type=script&lang=js"
import style0 from "./Canciones.vue?vue&type=style&index=0&id=2d9209be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9209be",
  null
  
)

export default component.exports